export enum NotificationType {
    APPOINTMENT = "Appointments",
    ANNOUCEMENT = "Announcements",
    PROMOTION = "Promotion"
}